<template lang="pug">
    #drag(ref="drag", @mousemove.prevent="mouseMove", @touchmove.prevent="mouseMove")
        .faelplus.notebook(ref="faelplus", @click="$eventBus.$emit('openExperiencia', 'faelPlus')")
            img(:src="require('@images/others/tela-faelplus.png')", alt="Fael +: Muito além do tradicional")
        .faelflix.notebook(ref="faelflix", @click="$eventBus.$emit('openExperiencia', 'faelflix')")
            img(:src="require('@images/others/tela-faelflix.png')", alt="FAELFlix: Conteúdo de sobra para o seu conhecimento")
        .marker(ref="marker", @mousedown.prevent="mouseDown", @touchstart.prevent="mouseDown")
            .arrows(ref="arrows")
</template>

<script>
export default {
    name: "drag",
    data() {
        return {
            clicked: false,
            initialPosition: null,
            padding: 0.155, // porcentagem a ser considerada
            trigger: 0.05, // margem de erro
        }
    },
    computed: {
        dragSize() {
            return this.$devinho.getWidth(this.$refs.drag)
        },
        dragOffset() {
            return this.$refs.drag.offsetLeft
        },
        faelPlusSize() {
            return this.$devinho.getWidth(this.$refs.faelplus)
        },
        faelFlixSize() {
            return this.$devinho.getWidth(this.$refs.faelflix)
        },
        maxDragArea() {
            return this.dragSize - (this.dragSize * this.padding)
        },
        minDragArea() {
            return this.dragSize * this.padding
        }
    },
    mounted() {
        this.$eventBus.$on('mouseup', this.mouseUp)
        this.$eventBus.$on('setDragPosition', this.setDragPosition)
    },
    methods: {
        mouseDown(event) {
            let positionX = event instanceof TouchEvent ? event.targetTouches[0].pageX : event.x
            this.clicked = true
            this.$refs.arrows.style.cursor = "grabbing"
            this.initialPosition = positionX - this.dragOffset
        },
        mouseUp() {
            this.clicked = false
            this.$refs.arrows.style.cursor = "grab"
        },
        mouseMove(event) {
            if (this.clicked) {
                let positionX = event instanceof TouchEvent ? event.targetTouches[0].pageX : event.x
                let mousePosition = positionX - this.dragOffset
                let imagePosition = ((this.dragSize - mousePosition) * 100) / this.dragSize

                if (mousePosition > this.initialPosition)
                    this.setDragPosition(mousePosition, imagePosition, 'right')
                else
                    this.setDragPosition(mousePosition, imagePosition, 'left')
            }
        },
        setDragPosition(markerPosition, imagePosition = null, direction = 'right') {
            if (typeof markerPosition === 'object') {
                imagePosition = markerPosition.imagePosition
                direction = markerPosition.direction || 'right'
                markerPosition = markerPosition.markerPosition 
            }

            this.$refs.faelflix.style.width = imagePosition + '%'

            if (direction == 'left') {
                let posTrigger = this.dragSize * (this.padding + this.trigger)
                this.$refs.marker.style.left = markerPosition >= this.minDragArea ? markerPosition + 'px' : this.minDragArea + 'px'
                if (markerPosition < posTrigger)
                    this.$eventBus.$emit('experienciaFael', 'faelflix')
            } else {
                let posTrigger = this.dragSize - (this.dragSize * (this.padding + this.trigger))
                this.$refs.marker.style.left = markerPosition <= this.maxDragArea ? markerPosition + 'px' : this.maxDragArea + 'px'
                if (markerPosition > posTrigger)
                    this.$eventBus.$emit('experienciaFael', 'faelPlus')
            }
        }
    },
}
</script>

<style lang="stylus" scoped src="@components/Drag/Drag.styl"></style>